export const isBasketLocation = () => {
    return location.pathname === '/basket';
}